import React from 'react';
import {PROVIDER_SUB_VIEW_MODEL} from "../../../Model/Model";
import RequestSubView from "../../../../Dashboard/Contractors/RequestDocumentation/SubComponents/RequestSubView";
import ApprovalFlowSubView from "../../../../DocumentationApprovalFlow/SubComponents/ApprovalFlowSubView";

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const DocumentationTab = ({
                              subView, setSubView, handleSubViewChange,search,setSearch, setSimpleSearch,
                              DEV, permission, searchElement, setSearchElement, deleteApprovalFlowShow,option,
                              setIsAllChecked, setDeleteApprovalFlowShow, selectedList, setSelectedList,
                              searchId, viewType, userTypeId
                          }) => {

    return (
        <>
            {subView === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW && (
                <ApprovalFlowSubView
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    DEV={DEV}
                    option={option}
                    permission={permission}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    deleteApprovalFlowShow={deleteApprovalFlowShow}
                    setIsAllChecked={setIsAllChecked}
                    setDeleteApprovalFlowShow={setDeleteApprovalFlowShow}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    searchId={searchId}
                    viewType={viewType}
                    userTypeId={userTypeId}
                />
            )}

            {subView === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.REQUESTS && (
                <RequestSubView
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    DEV={DEV}
                    permission={permission}
                    searchId={searchId}
                    option={option}
                    viewType={viewType}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    userTypeId={userTypeId}
                />
            )}
        </>
    );
};

export default DocumentationTab;
